function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSavedfilter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.172,
    height: 101.195,
    viewBox: "0 0 97.172 101.195",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17468"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50909",
    d: "M48.429 16.345 45.962 0H9.776A9.808 9.808 0 0 0 0 9.888v68.428a9.732 9.732 0 0 0 9.776 9.8H44.1L68.832 50.67v-26.7zm0 0",
    style: {
      fill: "#4394ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50910",
    d: "m285.277.141 22.8 23.946H292.9a7.617 7.617 0 0 1-7.623-7.623zm0 0",
    transform: "translate(-239.314 -.118)",
    style: {
      fill: "#006cfc"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17403"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50911",
    d: "M86.852 323.16h29.214a2.242 2.242 0 1 0 0-4.484H86.852a2.242 2.242 0 1 0 0 4.484zm0 0",
    transform: "translate(-70.978 -267.333)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50912",
    d: "M86.852 253.582h22.712a2.242 2.242 0 1 0 0-4.484H86.852a2.242 2.242 0 1 0 0 4.484zm0 0",
    transform: "translate(-70.978 -208.965)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50913",
    d: "M108.689 389.648H86.852a2.242 2.242 0 1 0 0 4.484h21.837a2.242 2.242 0 1 0 0-4.484zm0 0",
    transform: "translate(-70.978 -326.871)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17467"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50914",
    d: "M257.183 285.292a28.507 28.507 0 1 1-3.991-.292 33.82 33.82 0 0 1 3.991.292zm0 0",
    transform: "translate(-184.605 -241)",
    style: {
      fill: "#00d2a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.908 0H28.129a2.1 2.1 0 0 0-2.107 2.016V22.4a1.562 1.562 0 0 0 .266.906 1.031 1.031 0 0 0 .851.443 1.537 1.537 0 0 0 .976-.412l6.164-5.237a1.221 1.221 0 0 1 1.5 0l6.144 5.233a1.483 1.483 0 0 0 .953.412c.541 0 1.068-.417 1.068-1.349V2.016A2.038 2.038 0 0 0 41.908 0z",
    transform: "translate(32.979 60)",
    style: {
      fill: "#fff"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSavedfilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/savedfilter.cf5012902c90ec07705ab8169424673f.svg";